import qsLib from 'qs';

const parse = (qsStr: string) => {
  const __qs = qsStr.slice(1);
  return qsLib.parse(__qs);
};

export const qs = {parse};
